import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import axiosInstance from "../../interceptor/axiosInstance";
import { Institutes } from "../../models/InstituteModel/institutes.model";
import { deserialize, serialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { generatePath } from "react-router-dom";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";

export default class InstituteService {

    static fetchInstitutes(
        params: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        axiosInstance
            .get(ApiRoutes.INSTITUTES_LIST, {params})
            .then((response) => {
                const institutes = deserialize(Institutes, response.data["institutes"]);
                const pageMeta = deserialize(PaginationModel,response.data['meta']);
                onSuccess(institutes, pageMeta);
            })
            .catch((error) => {
                Notification({
                    message: "Problem in fetching institutes",
                    description: "Please try again!",
                    type: NotificationTypes.ERROR,
                });
                onError();
            })
            .finally(() => {
                onFinal();
            });
    }

    static showInstitute(
        instituteId: string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        const API_URL = generatePath(ApiRoutes.SINGLE_INSTITUTE, {instituteId});
        axiosInstance
            .get(API_URL)
            .then((response) => {
                const institute = deserialize(Institutes, response.data["institute"]);
                onSuccess(institute);
            })
            .catch((error) => {
                Notification({
                    message: "Problem in fetching institute",
                    description: "Please try again!",
                    type: NotificationTypes.ERROR,
                });
                onError();
            })
            .finally(() => {
                onFinal();
            });
    }

    static createInstitute(
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        axiosInstance
            .post(ApiRoutes.INSTITUTES_LIST, data, {headers:{'Content-Type':'multipart/form-data'}})
            .then((response) => {
                const institute = deserialize(Institutes, response.data["institute"]);
                onSuccess(institute);
            })
            .catch((error) => {
                Notification({
                    message: "Problem in creating institute",
                    description: "Please try again!",
                    type: NotificationTypes.ERROR,
                });
                onError();
            })
            .finally(() => {
                onFinal();
            });
    }

    static updateInstitute(
        instituteId: any,
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        const API_URL = generatePath(ApiRoutes.SINGLE_INSTITUTE, {instituteId});
        axiosInstance
            .put(API_URL, data, {headers:{'Content-Type':'multipart/form-data'}})
            .then((response) => {
                const institute = deserialize(Institutes, response.data["institute"]);
                onSuccess(institute);
            })
            .catch((error) => {
                Notification({
                    message: "Problem in updating institute",
                    description: "Please try again!",
                    type: NotificationTypes.ERROR,
                });
                onError();
            })
            .finally(() => {
                onFinal();
            });
    }

    static deleteInstitute(
        instituteId: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        const API_URL = generatePath(ApiRoutes.SINGLE_INSTITUTE, {instituteId});
        axiosInstance
            .delete(API_URL)
            .then((response) => {
                onSuccess();
            })
            .catch((error) => {
                Notification({
                    message: "Problem in deleting institute",
                    description: "Please try again!",
                    type: NotificationTypes.ERROR,
                });
                onError();
            })
            .finally(() => {
                onFinal();
            });
    }

}
